export enum AiResponseReviewRating {
  Unknown = "unknown",
  None = "none",
  Good = "good",
  Bad = "bad"
}

export enum FilterBoolEnum {
  Yes = "yes",
  No = "no",
  All = "all"
}

export enum SortAiResponseReviewColumnEnum {
  Unknown = "unknown",
  CreatedDate = "createdDate",
  Client = "client",
  ClientName = "clientName",  
  Project = "project",
  Environment = "environment",
  User = "user",
  UserName = "userName",
  Prompt = "prompt",
  ResponseId = "responseId",
  ResponseTime = "responseTime",
  UserRating = "userRating",
  UserReason = "userReason",
  InternalRating = "internalRating",
  InternalReason = "internalReason",
  LastUpdatedInternal = "lastUpdatedInternal",
  SemanticKernelTemperature = "semanticKernelTemperature",
  SearchServiceScoreCutoff = "searchServiceScoreCutoff",
  SearchServiceMaximumDefinitions = "searchServiceMaximumDefinitions",
  TableGenerated = "tableGenerated",
  TableDownloaded = "tableDownloaded",
  PreviousSqlLoaded = "previousSqlLoaded"
}

export enum SortDirectionEnum {
  Unknown = "unknown",
  None = "none",
  Descending = "descending",
  Ascending = "ascending"
}
